/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_User_MenuInputs */

const cs_nav_user_menu = /** @type {(inputs: Nav_User_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu účtu`)
};

const en_nav_user_menu = /** @type {(inputs: Nav_User_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account menu`)
};

/**
* | output |
* | --- |
* | "Account menu" |
*
* @param {Nav_User_MenuInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_user_menu = /** @type {((inputs?: Nav_User_MenuInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_User_MenuInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_user_menu(inputs)
	return cs_nav_user_menu(inputs)
});